import React from 'react';
import './Logo.scss';

export function Logo(props: {
  width: number;
  color?: string;
  animation?: boolean;
}) {
  const fillColor = props.color ? props.color : 'black';
  const anim = props.animation ? props.animation : false;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="remap-logo"
      viewBox="0 0 185.62 46.33"
      width={`${props.width}px`}
    >
      <path
        d="M4.18,43.36H2a2,2,0,0,1-2-2v-36a2,2,0,0,1,2-2H9.66c3.66,0,6,.72,7.92,2.4,2.4,2,3.6,5.1,3.6,9.06,0,4.41-1.38,7.63-4.14,9.61a2,2,0,0,0-.78,2.26l4.55,14.07a2,2,0,0,1-1.9,2.62H16.64A2,2,0,0,1,14.73,42L10.35,28.31a2,2,0,0,0-1.91-1.39H8.18a2,2,0,0,0-2,2V41.36a2,2,0,0,1-2,2M8.46,21.22c2.64,0,3.84-.3,4.8-1.26s1.5-2.64,1.5-4.86-.48-3.78-1.5-4.8S11.1,9,8.46,9H8.18a2,2,0,0,0-2,2v8.18a2,2,0,0,0,2,2Z"
        fill={fillColor}
      />
      <path
        d="M42.46,9H34.52a2,2,0,0,0-2,2V17.6a2,2,0,0,0,2,2h4.82a2,2,0,0,1,2,2v1.7a2,2,0,0,1-2,2H34.52a2,2,0,0,0-2,2v8.36a2,2,0,0,0,2,2h7.94a2,2,0,0,1,2,2v1.7a2,2,0,0,1-2,2H28.34a2,2,0,0,1-2-2v-36a2,2,0,0,1,2-2H42.46a2,2,0,0,1,2,2V7a2,2,0,0,1-2,2"
        fill={fillColor}
      />
      <path
        d="M86.82,46.33H58.9A6.91,6.91,0,0,1,52,39.44V6.89A6.91,6.91,0,0,1,58.9,0H86.82a6.91,6.91,0,0,1,6.89,6.89V39.44a6.91,6.91,0,0,1-6.89,6.89M68.93,13.64a1.27,1.27,0,0,0-1.22-.92H64A1.27,1.27,0,0,0,62.72,14V32.34A1.27,1.27,0,0,0,64,33.61h2a1.27,1.27,0,0,0,1.27-1.27V28.69a1.27,1.27,0,0,1,2.49-.43l1.36,4.45a1.27,1.27,0,0,0,1.21.9h1.12a1.27,1.27,0,0,0,1.21-.9L76,28.3a1.27,1.27,0,0,1,2.48.43v3.61a1.27,1.27,0,0,0,1.27,1.27h2A1.27,1.27,0,0,0,83,32.34V14a1.27,1.27,0,0,0-1.27-1.27H78a1.27,1.27,0,0,0-1.22.92L74.08,23a1.27,1.27,0,0,1-2.44,0l-2.71-9.38"
        fill={fillColor}
        className={[anim && 'logo-m'].join(' ')}
      />
      <path
        d="M132.82,46.33H104.9A6.91,6.91,0,0,1,98,39.44V6.89A6.91,6.91,0,0,1,104.9,0h27.92a6.91,6.91,0,0,1,6.88,6.89V39.44a6.91,6.91,0,0,1-6.88,6.89m-12-16.63a1.54,1.54,0,0,1,1.48,1.12l.47,1.67a1.52,1.52,0,0,0,1.47,1.12h1.58a1.53,1.53,0,0,0,1.45-2l-5.92-17.82a1.54,1.54,0,0,0-1.45-1h-2a1.55,1.55,0,0,0-1.46,1.06l-5.88,17.81a1.55,1.55,0,0,0,1.46,2h1.55A1.53,1.53,0,0,0,115,32.48l.46-1.65a1.54,1.54,0,0,1,1.48-1.13h3.88m-1.94-3.88a1.53,1.53,0,1,1,1.47-1.95,1.54,1.54,0,0,1-1.47,1.95h0"
        fill={fillColor}
        className={[anim && 'logo-a'].join(' ')}
      />
      <path
        d="M178.73,46.33H150.81a6.91,6.91,0,0,1-6.89-6.89V6.89A6.91,6.91,0,0,1,150.81,0h27.92a6.91,6.91,0,0,1,6.89,6.89V39.44a6.91,6.91,0,0,1-6.89,6.89M161.9,28.17a1.65,1.65,0,0,1,1.65-1.65h1.32a9.08,9.08,0,0,0,3-.48,6.5,6.5,0,0,0,2.3-1.36,5.87,5.87,0,0,0,1.44-2.12,7.13,7.13,0,0,0,.51-2.75,7.66,7.66,0,0,0-.51-2.83,6.3,6.3,0,0,0-1.44-2.25,6.75,6.75,0,0,0-2.3-1.48,8.37,8.37,0,0,0-3-.53H159a1.65,1.65,0,0,0-1.65,1.65V32A1.65,1.65,0,0,0,159,33.61h1.24A1.64,1.64,0,0,0,161.9,32V28.17m0-9.91a1.65,1.65,0,0,1,1.65-1.65h1.32a2.56,2.56,0,0,1,1.22.27,2.31,2.31,0,0,1,.84.71,3,3,0,0,1,.49,1,4.93,4.93,0,0,1,.15,1.23,4,4,0,0,1-.15,1.12,2.36,2.36,0,0,1-.49.88,2.24,2.24,0,0,1-.84.59,3.39,3.39,0,0,1-1.22.2h-1.32A1.64,1.64,0,0,1,161.9,21Z"
        fill={fillColor}
        className={[anim && 'logo-p'].join(' ')}
      />
    </svg>
  );
}
